<template>
<div class="vue-wrapper">
		<NotificationSchedule-Filters
			:columns="Columns"
			:totals="$store.getters['notificationScheduleList/getTotals']"
			:activeList="activeList"
			:callOptionMethod="$store.getters['notificationScheduleList/getGrid'][this.activeList].statusLookup"
			v-on:update:filters="onFilterArgUpdate"
			v-on:submit:filters="onSubmitFilters"
			v-on:submit:newschedule="onNewPrimaryNotificationSchedule"
            storeArgs="notificationScheduleArgs"
            storeModule="notificationScheduleList"
			storeFilter="notificationScheduleFilters"
			:showNewScheduleButton="canAddNotificationSchedule()"
		/>
	<b-container class="laneclosure-list notification-schedule-list wide">
		<Spinner v-show="loading"/>

		<slot>
			<div class="column-grid organization-table">
				<div class="row-wrap">
					<div class="col-24 m24 xl24 t-header">
						<div class="row-wrap heading">
							<div class="col-24 gutter hide-on-med-and-down"
								v-for="(column, index) in $store.getters['notificationScheduleList/getGrid'][activeList].columns"
								:key="'index'+index"
								:class="column.widths"
							>
								<caption class="column-title">
									<span v-text="column.alternateLabel ? column.alternateLabel : column.label" v-if="column.key != 'status'"></span>
									<b-form-select ref="filterIsActive" v-if="column.key == 'status'" :options="NotificationSchedule.isActiveOptions" v-model="filterIsActive.value"
									@input="onFilterIsActive"
									:state="filterIsActive.status"
									value-field="id"
									text-field="name"
									class="filter-record-status-id"
									size="sm"
									>
									</b-form-select>

									<img src="@/assets/downarrow.svg"
										class="ctrl-arrow"
										:class="{ 'show-map': !showMap && !column.sortable, 'asort': (column.key === $store.getters['notificationScheduleList/getParams'].sortBy) && ascOrder }"
										alt="downarrow"
										:data-key="column.sortable ? column.key : null"
										v-if="column.sortable || column.label.toLowerCase() === 'map'"
										@click="onColumnChevronToggle"
									/>
								</caption>
							</div>
						</div>
						<div v-for="(row, index) in Records" :key="'ii'+index"
							:class="`row-wrap records`" :style="getRowStyle(row)"
						>

							<div class="col-24 xs24 l6 gutter" @click="onRowSelected(index)">
								<div class="hide-on-med-and-down col-cta">
								<span v-html="getNotificationTypeText(row)"></span>
								</div>
								<span class="hide-on-large-and-up col-cta" @click="onRowSelected(index)" v-html="getNotificationTypeText(row)"></span>
								<hr class="hide-on-large-and-up"/>
							</div>

							<div class="col-24 xs24 l2 gutter" @click="onRowSelected(index)">
								<div class="hide-on-med-and-down col-cta">
								<span v-html="getStatus(row)"></span>
								</div>
								<span class="hide-on-large-and-up col-cta" @click="onRowSelected(index)" v-html="getStatus(row)"></span>
								<hr class="hide-on-large-and-up"/>
							</div>

							<div class="col-24 xs24 l6 gutter" @click="onRowSelected(index)">
								<div class="hide-on-med-and-down col-cta">
								<span v-html="row.appText"></span>
								</div>
								<span class="hide-on-large-and-up col-cta" @click="onRowSelected(index)" v-html="row.appText"></span>
								<hr class="hide-on-large-and-up"/>
							</div>

							<div class="col-24 xs24 l5 gutter" @click="onRowSelected(index)">
								<div class="hide-on-med-and-down col-cta">
								<span v-html="getMinutes(row)"></span>
								</div>
								<span class="hide-on-large-and-up col-cta" @click="onRowSelected(index)" v-html="getMinutes(row)"></span>
								<hr class="hide-on-large-and-up"/>
							</div>

							<div class="col-24 xs24 l5 gutter" @click="onRowSelected(index)">
								<div class="hide-on-med-and-down col-cta">
								<span v-html="NotificationSchedule.getLcrUserTypeText(row.lcrUser)"></span>
								</div>
								<span class="hide-on-large-and-up col-cta" @click="onRowSelected(index)" v-html="NotificationSchedule.getLcrUserTypeText(row.lcrUser)"></span>
								<hr class="hide-on-large-and-up"/>
							</div>



							<div class="col-24 l24 list-spacer hide-on-med-and-down"></div>
						</div>
					</div>
				</div>
			</div>
		</slot>
		<div class="paginateWrapper" v-show="!loading">
		<paginate
		:page-count="getPageCount"
		:page-range="3"
		:margin-pages="2"
		:click-handler="onPageClick"
		prev-text='<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-left" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" class="svg-inline--fa fa-chevron-left fa-w-10"><path fill="currentColor" d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z" class=""></path></svg>'
		next-text='<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" class="svg-inline--fa fa-chevron-right fa-w-10"><path fill="currentColor" d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z" class=""></path></svg>'
		:container-class="'page-ctrl'"
		:page-class="'page'"
		:next-class="'page-next'"
		:prev-class="'page-prev'"
		ref="notiSchedPaginator"
		v-model="page"
		>
		</paginate>
		</div>
	</b-container>
    </div>
</template>

<script>
import NotificationScheduleFilters from "./../../../components/NotificationScheduleFilters.vue"
import BootstrapField from './../../../utility/BootstrapField';

import Spinner from "./../../../components/Spinner.vue"
import NotificationSchedule from './../../../models/NotificationSchedule.js'

import Vue from 'vue'
import Format from '../../../utility/Format';


export default {
	components: {
		'NotificationSchedule-Filters': NotificationScheduleFilters,
		Spinner
	},
	mounted() {
		if (!this.$store.getters.userHasRole('system_admin')) {
			this.$router.push("/no-access");
		} else {
			this.forceArgUpdate();
			this.setEventBusOn();
		}
	},
	data() {
		return {
			NotificationSchedule:NotificationSchedule,
			showMap: false,
			activeList: 0,
			ascOrder: true,
			loading: true,
			page: 0,
			lastIndex: null,
			rowMapToggle:[],
			Records:[],
			currentPage:1,
			filterIsActive: new BootstrapField({
				value: null,
			}),
			filterApplied: false,
			storeModule:"notificationScheduleList",
			storeArgs:"notificationScheduleArgs",
		}
	},
	computed: {
		getPageCount() {
			let pageCount = 1;
			if (this.$store) {
				let pagination = this.$store.getters[this.storeModule+'/getPagination'];
				if (pagination) {
					if (pagination.count) {
						pageCount = Math.ceil(pagination.count / pagination.perPage);
						if (pageCount < 1) {
							pageCount = 1;
						}

					}
				}
			}
			return pageCount;
		},
		getPage() {
			let page = 1;
			if (this.$store) {
				let pagination = this.$store.getters[this.storeModule+'/getPagination'];
				if (pagination) {
					if (pagination.page >= 1) {
						return pagination.page;
					}
				}
			}
			return page;
		},
        Columns() {
			return this.$store.getters[this.storeModule+'/getGrid'][this.activeList].columns
		},
	},
	beforeDestroy() {
		this.setEventBusOff();
	},
	methods: {
        getDateCreated(entry) {
			return Format.toLocalDateTime(entry.createdDate, 'MMMM D, Y H:mm:ss');
        },
		canAddNotificationSchedule() {
			if (this.$store.getters.userHasRole('internal_admin_requests') || this.$store.getters.userHasRole('system_admin')) {
				return true;
			}
			return false;
		},
		onNewPrimaryNotificationSchedule(e) {
			this.$router.push("/admin/new-notification-schedule"+"?r="+Math.round(Math.random() * Math.pow(10, 6)));
		},

		getColumnClasses(key, index) {
		let classes =  "col-24 xs24 l8 gutter hide-on-med-and-down col-cta";
		classes += " value-" + key;
		if (key == "name") {
			classes += " level-" + this.Records[index].level;
		}
		return classes;
		},
		friendlyDateFromNow(dt) {
			return Format.diffYMDHMSAgo(dt, new Date);
		},
		setEventBusOff() {
			this.$bus.$off('update:pages', this.onPagePagination);

		},
		setEventBusOn() {
			this.setEventBusOff();
			this.$bus.$on('update:pages', this.onPagePagination);

		},
		onPageClick(value) {
			this.page = value
			this.$store.dispatch(this.storeModule+'/updateParams', { page: value } )
			this.fetchData()
		},
		onFilterIsActive() {
        this.$store.dispatch(this.storeModule+'/updateParams', { isActive: this.filterIsActive.value} )
		this.fetchData()
	},
		onSubmitFilters() {
			let argQuery = JSON.parse(localStorage.getItem(this.storeArgs))
			if (argQuery) {
				this.onFilterArgUpdate(argQuery)
			}
            this.$store.dispatch(this.storeModule+'/updateParams', { page: 1} )

			this.fetchData()
		},
		onStatusUpdate(index, name = null) {
			// always show the first page of results when setting parameters
			this.$store.dispatch('notificationScheduleList/clearStatusFilters');
			this.$store.dispatch('notificationScheduleList/updateParams', { page: 1 } );
			this.activeList = index;
			this.fetchData();
		},
		forceArgUpdate() {
			let argQuery = JSON.parse(localStorage.getItem(this.storeArgs))
			if (argQuery) {
				this.onFilterArgUpdate(argQuery)
			}
			this.fetchData()
		},
		onFilterArgUpdate(queryArg) {
			this.$store.dispatch('notificationScheduleList/updateParams', { page: 1 } );
			this.$store.dispatch('notificationScheduleList/updateParams', queryArg )
		},
		onPagePagination(value) {
			this.page = value
			this.$store.dispatch('notificationScheduleList/updatePagination', { page: value } )
		},
		fetchData() {
			document.getElementById('main').scrollTo(0,0)

			this.loading = true
			this.$store.dispatch('notificationScheduleList/loadViewable', this.$store.getters['notificationScheduleList/getParams'])
				.then(() => {
					this.loading = false;
					if(this.$store.getters['notificationScheduleList/getParams'].isActive) {
						if (this.filterIsActive.value !=  this.$store.getters['notificationScheduleList/getParams'].isActive) {
							this.filterIsActive.value =  this.$store.getters['notificationScheduleList/getParams'].isActive;
						}
					} else {
						this.filterIsActive.value = null;
					}
						this.Records = [];
						let records = this.$store.getters['notificationScheduleList/getRecords'];

						this.$store.getters['notificationScheduleList/getGrid'][this.activeList].statusLookup;
						if ( records ) {
							records.forEach( item => {
								this.Records.push(item);
							})
						}

					})
				.catch( error => console.log('error', error) )
		},
		onRowSelected(index) {
			this.$router.push({name:"EditNotificationSchedule", params:{id: this.Records[index].id}});
		},
		getNotificationTypeText(entry) {
			let txt = "";
			txt = NotificationSchedule.getNotificationScheduleTypeText(entry.notificationTypeId);
			return txt;
		},

		getMinutes(entry) {
			let txt = "";
			txt = NotificationSchedule.getMinutesText(entry.notificationTypeId, entry.fromMinute, entry.toMinute);
			return txt;
		},


		getStatus(entry) {
			let txt = "";
			if (entry.isActive == 1) {
				txt = "Active";
			} else {
				txt = "Disabled";
			}
			return txt;
		},

		getRowStyle(entry) {
			let style = "";
			style = "background:#eee;";
			if (entry.isActive == 1) {
				style ="";
			}
			return style;
		},



		onColumnChevronToggle(e, toggle = null) {
			e.preventDefault()
			if ( e.target.getAttribute('data-key') ) {
				if ( this.$store.getters['notificationScheduleList/getParams'].sortBy !== e.target.getAttribute('data-key') ) {
					this.$store.dispatch('notificationScheduleList/updateParams', { sortBy: e.target.getAttribute('data-key') } )
				}
				this.ascOrder = !this.ascOrder
				this.ascOrder ? e.target.classList.add('asort') : e.target.classList.remove('asort')
				this.$store.dispatch('notificationScheduleList/updateParams', { sortOrder: this.ascOrder ? 'asc' : 'desc' } )
				this.fetchData()
			} else {
				Vue.prototype.$bus.$emit("map:toggle", e, toggle)
			}
		},
		parseOwner(item) {
			let owner = item.owner ? `${item.owner.firstName} ${item.owner.lastName}<sup class="e-owner"></sup><br class="hide-on-med-and-down"/>` : '',
				requester = item.requester ? `${item.requester.firstName} ${item.requester.lastName}<sup class="e-requester"></sup><br class="hide-on-med-and-down"/>` : '',
				alternate = item.alternate ? `${item.alternate.firstName} ${item.alternate.lastName}<sup class="e-alternate"></sup><br class="hide-on-med-and-down"/>` : ''
			owner += owner && requester ? '<span class="hide-on-large-and-up"> / </span>'+requester : requester
			owner += owner && alternate ? '<span class="hide-on-large-and-up"> / </span>'+alternate : alternate
			return owner
		},
		parseLocation(loc1, loc2, loc3) {
			let location = loc1 ? loc1 : ' '
			location = location && loc2 ? `${location}, ${loc2 ? loc2 : ' '}` : location
			location = location && loc3 ? `${location} to ${loc3 ? loc3 : ' '}` : location
			return location
		},
		strReplace(string, searchValue, newValue) {
			if (typeof string === 'string') {
				return string.replace(searchValue, newValue)
			}
			return string
		}
	},
	beforeRouteEnter(to, from, next) {
	next(vm => {
	Vue.prototype.$bus.$emit("map:clear", 1);
	Vue.prototype.$bus.$emit("map:toggle", 0);
	});
	},

	beforeRouteLeave(to, from, next) {
		Vue.prototype.$bus.$emit("map:clear", 1);
		Vue.prototype.$bus.$emit("map:toggle", 0);
		next(true);
	},

}
</script>
